import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';
import { IShippingData } from 'interfaces/IProductData';
import { paymentService } from './PaymentService';
import { cartService } from 'services/CartService';
import { IS_ECOMMERCE } from 'settings';
import { enProductType } from 'enums/enProductType';

export class ShippingService {
  private shipping$ = new ReplaySubject<IShippingData>(1);
  private loaded = false;

  constructor() {
    cartService
      .getCart()
      .combineLatest(paymentService.getCart())
      .filter(([cart, payment]) => {
        if (IS_ECOMMERCE || cart.isCached) {
          return false;
        }

        if (cart.config.mustEstimate) {
          return true;
        }

        if (cart.pins) {
          return true;
        }

        if ([enProductType.PHYSICAL, enProductType.TICKET].includes(payment.productType)) {
          return true;
        }

        return false;
      })
      .map(([cart, payment]) => {
        const data = {
          postalCode: (payment.address && payment.address.postalCode) || '',
          quantity: Number(payment.quantity || 0),
          price: payment.fullPrice,
          coupon: cart.coupon,
          lang: cart.config.lang,
          mustEstimate: cart.config.mustEstimate
        };

        return data;
      })
      .filter(data => data.mustEstimate)
      .distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b))
      .debounceTime(500)
      .switchMap(data => {
        const shipping$ = cartService.setShippingData(data.quantity, data.postalCode);

        if (this.loaded === false) {
          return shipping$;
        }

        return shipping$.loader();
      })
      .subscribe(shippings => {
        this.loaded = true;
        this.shipping$.next(shippings);

        if (shippings.shippingItems.length > 0) {
          cartService.setShipping(shippings.hash, shippings.shippingItems[0]);
        }
      });
  }

  public getShipping(): Observable<IShippingData> {
    return this.shipping$.asObservable().distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b));
  }
}

// tslint:disable-next-line:variable-name
export const ShippingServiceFactory = () => new ShippingService();

export const shippingService = ShippingServiceFactory();
